import { CreateButton } from '@/components';
import type { FC } from 'react';
import { useDrawerState } from './DrawerStateProvider';

export const CreatePolicyButton: FC = () => {
  const { setDrawerState } = useDrawerState();

  return (
    <>
      <CreateButton
        onCreate={() => {
          setDrawerState({ open: true, type: 'policy', isEditing: false });
        }}
      />
    </>
  );
};
